import React from 'react';
import PropTypes from 'prop-types';
import componentBase from '../../../../../../../src/lib/component-base';

@componentBase('FlightCodesharesComponent')
export default class FlightCodesharesComponent extends React.Component {
  static propTypes = {
    codeshares: PropTypes.array,
  };

  static defaultProps = {
    codeshares: null,
    codesharesDescription: null,
  };

  constructor(props, context) {
    super(props, context);

    this.muiDefaultProps = {
      divStyle: {
        margin: '5px 10px 25px',
        minHeight: '1px',
      },
      textStyle: {
        margin: 0,
        fontSize: '16pt',
      },
      codeshareTextStyle: {
        margin: '0 10px 0 0',
        fontSize: '12pt',
        display: 'inline-block',
        color: 'rgba(255,255,255,0.7)',
      },
    };
  }

  render() {
    if (this.props.codeshares && this.props.codeshares.length > 0) {
      const codesharesDisplayElement = [];
      this.props.codeshares.forEach((codeshare, i) => {
        const key = `flightcodeshare${i}`;
        codesharesDisplayElement.push(<p key={key} style={this.muiDefaultProps.codeshareTextStyle}>
                                        ({codeshare.fs}) {codeshare.name} {codeshare.flightNumber}
        </p>);
      });

      return (
        <div style={this.muiDefaultProps.divStyle}>
          <h4 style={this.muiDefaultProps.textStyle}>This Flight Also Marketed As</h4>
          {codesharesDisplayElement}
        </div>
      );
    }

    return (<div style={this.muiDefaultProps.divStyle} />);
  }
}



// WEBPACK FOOTER //
// ./modules/SingleFlight/children/FlightTracker/children/FlightInformation/children/FlightCodesharesComponent.js